import ApiClient from '@afosto/api/ApiClient';

class Bulk {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Bulk change
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update items in bulk
   * @returns {Promise}
   */
  bulkUpdateItems(body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/bulk/items`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const bulk = new Bulk();

export default Bulk;
